import { type CostGroupEnum, WorkOrderStatusEnum } from 'gql/graphql';
import type { ActKc2StatusEnum } from 'gql/graphql';

import { ActKC2Copy } from './ActKC2Copy';
import { ActKC2Delete } from './ActKC2Delete';

interface IActKC2ToolsProps {
    costGroup?: CostGroupEnum;
    statusWorkOrder?: WorkOrderStatusEnum;
    actKc2Id?: number;
    number?: number;
    date?: Date | null;
    status?: ActKc2StatusEnum;
    onRefresh?: () => void;
    isInactive?: boolean;
}

export const ActKC2Tools = ({
    actKc2Id,
    number,
    date,
    status,
    onRefresh,
    statusWorkOrder,
    isInactive,
    costGroup,
}: IActKC2ToolsProps) => {
    const isStatusWorkOrderDelayed = statusWorkOrder === WorkOrderStatusEnum.Delayed;
    const isStatusWorkOrderCompleted = statusWorkOrder === WorkOrderStatusEnum.Completed;

    const isDisabledByWorkOrderStatus = isStatusWorkOrderDelayed || isStatusWorkOrderCompleted;

    return (
        <>
            <ActKC2Copy
                actKc2Id={actKc2Id}
                number={number}
                date={date}
                onCopy={onRefresh}
                isDisabled={isDisabledByWorkOrderStatus || isInactive}
            />
            <ActKC2Delete
                actKC2Id={actKc2Id}
                number={number}
                date={date}
                costGroup={costGroup}
                onDelete={onRefresh}
                status={status}
                isDisabled={isDisabledByWorkOrderStatus}
            />
        </>
    );
};

ActKC2Tools.displayName = 'ActKC2Tools';
